import { useMemo } from "react";
import { useLocation } from "react-router";

export interface AutoContext {
  clientId: string | null;
  flowInstanceId: string | null;
}

function parseContext(pathname: string): AutoContext {
  const flowMatch = pathname.match(/^\/clients\/([^/]+)\/flows\/([^/]+)/);
  if (flowMatch) return { clientId: flowMatch[1], flowInstanceId: flowMatch[2] };

  const clientMatch = pathname.match(/^\/clients\/([^/]+)/);
  if (clientMatch) return { clientId: clientMatch[1], flowInstanceId: null };

  return { clientId: null, flowInstanceId: null };
}

/**
 * Detects the current client and flow instance from the URL.
 * - /clients/:id/* → sets clientId
 * - /clients/:id/flows/:instanceId/* → sets clientId + flowInstanceId
 * - Other routes → clears both
 */
export function useAutoContext(): AutoContext {
  const location = useLocation();
  return useMemo(() => parseContext(location.pathname), [location.pathname]);
}
